import React from 'react';
import Hero from '../components/Hero';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Location from '../components/Location';
import ImageGrid from '../components/ImageGrid';
import InteriorGallery from '../components/InteriorGallery';
import ContentSection from '../components/ContentSection';
import VideoContentSection from '../components/VideoContentSection';
import Featuring from '../components/Featuring';
import welcomeVideo from '../assets/MOV_0023.MOV';
import lineDanceVideo from '../assets/Don Highlands Line Dance.MOV';
import contentImg1 from '../assets/747A5717.JPG';
import contentImg2 from '../assets/747A5736.JPG';
import salmonImg from '../assets/food/Salmon.jpeg';
import saladImg from '../assets/food/Salad.jpeg';
import beerFlightImg from '../assets/food/beer_flight.jpg';

// Create a data URL for a grey rectangle SVG with text
const placeholderImage = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
  `<svg width="800" height="800" xmlns="http://www.w3.org/2000/svg">
    <rect width="100%" height="100%" fill="#E5E5E5"/>
    <text x="50%" y="50%" font-family="Inter, sans-serif" font-size="24" fill="#666" text-anchor="middle" dominant-baseline="middle">
      image here
    </text>
  </svg>`
)}`;

// Updated image references
const contentImage1 = contentImg1;
const contentImage2 = contentImg2;
const contentImage3 = placeholderImage;
const contentImage4 = placeholderImage;

const Home = () => {
  const gridImages1 = [
    { src: placeholderImage, alt: 'Highlands dining experience' },
    { src: placeholderImage, alt: 'Delicious food at Highlands' },
    { src: placeholderImage, alt: 'Highlands menu highlights' },
    { src: placeholderImage, alt: 'Sports bar atmosphere' },
    { src: placeholderImage, alt: 'Signature dishes' },
    { src: placeholderImage, alt: 'Highlands drinks and beverages' }
  ];

  return (
    <>
      <Hero />
      <VideoContentSection
        title="Welcome to Highlands"
        description="Experience the perfect blend of delicious food, refreshing drinks, and a vibrant sports bar atmosphere. Join us for an unforgettable dining experience in the heart of San Carlos."
        videoSrc={welcomeVideo}
        videoOnRight={true}
        ctaButton={{
          text: "View Menu",
          link: "/menu"
        }}
      />
      <ContentSection
        title="Juicy Classic Cheeseburger & Fries!"
        description="Sink your teeth into our mouthwatering Classic Cheeseburger, featuring a perfectly seasoned beef patty, melted cheese, and fresh toppings all nestled in a soft, toasted bun. Served with crispy, golden fries on the side for the ultimate comfort food experience. A satisfying, timeless favorite for every burger lover!"
        image={contentImage1}
        imageAlt="Classic Cheeseburger and Fries"
        imageOnRight={false}
      />
      <ContentSection
        title="Artisanal Pizza Perfection"
        description="Experience pizza paradise with our hand-crafted creations! Each pizza starts with our perfectly crispy crust, topped with house-made marinara sauce, premium melted cheeses, and your choice of fresh toppings. Whether you're a classic pepperoni fan or adventurous with specialty combinations, our pizzas are guaranteed to satisfy your cravings!"
        image={contentImage2}
        imageAlt="Fresh-baked artisanal pizza"
        imageOnRight={true}
      />
      <ContentSection
        title="Fresh & Flavorful Salads"
        description="Elevate your dining experience with our fresh, chef-crafted salads. Each bowl features crisp, seasonal ingredients, perfectly balanced with house-made dressings. Whether you're looking for a light lunch or a healthy dinner option, our salads offer the perfect blend of nutrition and incredible taste."
        image={saladImg}
        imageAlt="Fresh gourmet salad with premium toppings"
        imageOnRight={false}
      />
      <InteriorGallery 
        title="Take a Look Inside"
        description="Discover our welcoming space featuring comfortable booths, accessible facilities, and a dog-friendly outdoor patio perfect for everyone to enjoy."
      />
      <ContentSection
        title="Craft Beer Paradise"
        description="Explore our impressive selection of over 36 beers on tap, including a rotating selection of local craft brews. Try our popular beer flights to sample different flavors and find your new favorite!"
        image={beerFlightImg}
        imageAlt="Beer flight selection at Highlands"
        imageOnRight={false}
      />
      <ContentSection
        title="Bring Bold Flavors to Your Next Event!"
        description="Make your next event truly memorable with catering from Highlands Sports Bar & Grill! Whether you're craving juicy burgers, smoky BBQ, or fresh salads, we bring delicious, high-quality dishes perfect for any occasion. Let us take care of the food, so you can focus on enjoying the fun and creating lasting memories!"
        image={salmonImg}
        imageAlt="Catering spread from Highlands Sports Bar & Grill"
        imageOnRight={true}
        ctaButton={{
          text: "Cater With Us",
          link: "/catering"
        }}
      />
      <VideoContentSection
        title="Come For Saturday Night Line Dancing"
        description="Join us every Saturday night for an unforgettable evening of line dancing! Whether you're a seasoned dancer or just starting out, our energetic atmosphere and friendly community make it the perfect place to kick up your heels and have some fun. Get ready to learn new moves, meet great people, and create lasting memories on our dance floor!"
        videoSrc={lineDanceVideo}
        videoOnRight={false}
      />
      <Testimonials />
      <Featuring />
      <Location />
    </>
  );
};

export default Home; 